import { render, staticRenderFns } from "./MapaPagamentos.vue?vue&type=template&id=2390e64a&"
import script from "./MapaPagamentos.vue?vue&type=script&lang=js&"
export * from "./MapaPagamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports